module.exports = __webpack_public_path__ + "static/sprite-a69a2488a6d988f25f0c328a4e5c95c2.webp";